import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";

const TABLE_HEAD = ["#", "عنوان", "توضیحات", "اولویت", "وضعیت", "عملیات"];

export function FieldGrid({fields, setModalOpen, setSelectedRow}) {

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "عنوان": "title",
    "توضیحات": "description",
    "اولویت": "order_by",
    "وضعیت": "status",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "عنوان": true,
    "توضیحات": true,
    "اولویت": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {fields.map(
          ({
             id,
             title,
             description,
             order_by,
             status
           }, index) => {
            const isLast = index === fields.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(order_by)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setSelectedRow(fields[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}